export default __webpack_public_path__ + "static/media/fAbeNcake_w640.ea7eb6df.jpeg";